module.exports = __webpack_public_path__ + "static/media/locMap.1b0d0e9b.svg";